/* eslint-disable react/display-name */
/* eslint-disable import/no-anonymous-default-export */

import ReactECharts from 'echarts-for-react';
import React from 'react';
import styled from 'styled-components';

import { Avatar } from '~/_legacy/components/atoms/avatar/index';

import * as COLORS from '~/colors';
import { Futura } from '~/styles';
import { media } from '~/utils';

export default function ({ org }) {
  const { demographics } = org;
  const [tab, setTab] = React.useState(0);

  const demographic = demographics[tab];
  const data = demographic.values;

  const option = {
    tooltip: {
      trigger: 'item',
    },
    color: COLORS.chart,
    series: [
      {
        name: demographic.name,
        type: 'pie',
        radius: ['45%', '70%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
        },
        emphasis: {
          label: {
            show: false,
          },
        },
        labelLine: {
          show: false,
        },
        data,
      },
    ],
  };

  return (
    <Wrapper>
      <Title>フォロワー</Title>
      <Follower>
        <FollowerCount>{org.followerCount}人</FollowerCount>
      </Follower>
      <Title>デモグラフィック</Title>
      <Tabs>
        {demographics.map((d, i) => (
          <Tab key={i} active={tab === i} onClick={() => setTab(i)}>
            {d.name}
          </Tab>
        ))}
      </Tabs>
      <Demographic>
        <ChartArea>
          <ReactECharts option={option} opts={{ height: '200px' }} />
        </ChartArea>
        <Right>
          <RightTitle>フォロワーの{demographic.name}</RightTitle>
          <Names>
            {demographic.values.map((v, i) => (
              <NameLine key={i}>
                <Color color={COLORS.chart[i]} />
                <Number>{i + 1} :</Number>
                <Name>{v.name}</Name>
              </NameLine>
            ))}
          </Names>
        </Right>
      </Demographic>
      <Followers>
        {org.followers.map((f, i) => (
          <User key={i}>
            <Avatar size={'50px'} src={f.avatar} />
            <UserName>{f.name} さん</UserName>
          </User>
        ))}
      </Followers>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
`;

const Title = styled.div`
  margin-top: 5px;
  margin-left: 10px;
  font-size: 12px;
  font-weight: bold;
  color: #2c2c2c;
`;

const Follower = styled.div``;

const FollowerCount = styled.div`
  padding-left: 80px;
  height: 80px;
  line-height: 80px;
  font-size: 20px;
  font-weight: bold;
  color: #2c2c2c;
  border-bottom: 1px solid #b2b2b2;
`;

const Tabs = styled.div`
  margin-top: 18px;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const Tab = styled.div`
  margin-left: 20px;
  width: 120px;
  font-size: 16px;
  font-weight: bold;
  color: ${(props) => (props.active ? '#fff' : '#585858')};
  background: ${(props) => (props.active ? '#585858' : '#fff')};
  height: 36px;
  line-height: 36px;
  border: 1px solid #585858;
  border-radius: 18px;
  text-align: center;

  &:first-child {
    margin-left: 0;
  }

  ${media.mid`
    width: 80px;
    margin-left: 12px;
  `}
`;

const Demographic = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  ${media.mid`
    flex-direction: column;
  `}
`;

const ChartArea = styled.div`
  width: 400px;
  height: 200px;
`;

const Right = styled.div``;

const RightTitle = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: #1f1f1f;
`;

const Names = styled.div`
  margin-top: 5px;
`;

const NameLine = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Color = styled.div`
  width: 40px;
  height: 20px;
  border-radius: 10px;
  background: ${(props) => props.color};
`;

const Number = styled(Futura)`
  margin-left: 10px;
  font-size: 16px;
  color: #070707;
  font-weight: bold;
`;

const Name = styled.div`
  margin-left: 10px;
  font-size: 16px;
  color: #3c3c3c;
  font-weight: bold;
  position: relative;
  top: -1px;
`;

const Followers = styled.div`
  padding: 10px 80px 40px;
  border-top: 1px solid #b2b2b2;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;

  ${media.mid`
    margin-top: 40px;
    padding-left: 35px;
  `}
`;

const User = styled.div`
  margin-top: 20px;
  width: 300px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const UserName = styled.div`
  margin-left: 20px;
  font-size: 14px;
  font-weight: bold;
  color: #505050;
`;
